<template>
  <div class="content">
    <form class="form-horizontal" @submit.prevent="">
      <div class="row">
        <div class="col-sm-6">
          <el-select class="select-primary" size="large" placeholder="파일 불러오기" v-model="id">
            <el-option v-for="option in list" class="select-primary" :value="option.id" :label="option.label" :key="option.label"></el-option>
          </el-select>
          <base-button @click="loadFile()" type="danger">불러오기</base-button>
        </div>
        <div class="col-sm-6">
          {{ path }}
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <base-input placeholder="내용">
            <textarea class="form-control langData" rows="100" v-model="json" />
          </base-input>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <base-button @click="onSubmit" type="success">등록</base-button>
          <base-button @click="clearCache()" type="danger">서버적용</base-button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { BaseButton, BaseInput } from "@/components/index";
import swal from "sweetalert2";

export default {
  components: {
    BaseInput,
    BaseButton,
  },
  async created() {},
  data() {
    return {
      json: null,
      id: null,
      path: null,
      list: [
        { id: 1, label: "안드로이드 점검", loadPath: "/systemAnnouncements", savePath: "systemAnnouncements", fileName: "android" },
        { id: 2, label: "아이폰 점검", loadPath: "/systemAnnouncements", savePath: "systemAnnouncements", fileName: "ios" },
        { id: 3, label: "글감", loadPath: "/nudge", savePath: "nudge", fileName: "writing.json" },
        { id: 4, label: "프레임목록", loadPath: "/template/frames", savePath: "template/frames", fileName: "list.json" },
        { id: 5, label: "스킨목록", loadPath: "/template/skins", savePath: "template/skins", fileName: "list.json" },
        { id: 6, label: "템플릿목록", loadPath: "/template/templates", savePath: "template/templates", fileName: "list.json" },
        { id: 7, label: "스티커목록", loadPath: "/template/stickers", savePath: "template/stickers", fileName: "list.json" },
        { id: 8, label: "결제 관련", loadPath: "/systemAnnouncements", savePath: "systemAnnouncements", fileName: "payment.json" },
        { id: 9, label: "이벤트 관련", loadPath: "/event", savePath: "event", fileName: "invitation.json" },
        { id: 10, label: "챌린지", loadPath: "/challenge", savePath: "challenge", fileName: "challenge.json" },
        { id: 11, label: "광고 설정", loadPath: "/advertise", savePath: "advertise", fileName: "advertise.json" },
        { id: 12, label: "공지 모달", loadPath: "/noticeModal", savePath: "noticeModal", fileName: "noticeModal_new.json" },
        { id: 13, label: "광고 설정 v2", loadPath: "/advertise", savePath: "advertise", fileName: "advertise_v2.json" },
      ],
    };
  },
  methods: {
    async loadFile() {
      if (!this.id) {
        return;
      }
      const item = _.find(this.list, { id: this.id });
      this.path = `${item.loadPath}/${item.fileName}`;
      return this.$axios.get(`/file?path=${item.loadPath}&fileName=${item.fileName}`).then((res) => {
        this.json = JSON.stringify(res.data.data, null, 2);
      });
    },
    async clearCache() {
      const item = _.find(this.list, { id: this.id });
      const path = item.loadPath;
      const fileName = item.fileName;
      await this.$axios.post(`/file/invalidate`, { path, fileName });
      Toast.success("캐시가 초기화되었습니다");
    },

    async onSubmit() {
      if (!this.isJsonString(this.json)) {
        Toast.error("유효하지 않은 JSON");
        return;
      }
      swal
        .fire({
          title: "등록 확인",
          text: `등록 하시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-danger btn-fill",
            cancelButton: "btn btn-cancel btn-fill",
          },
          confirmButtonText: "등록",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            const item = _.find(this.list, { id: this.id });
            const path = item.savePath;
            const fileName = item.fileName;
            await this.$axios.post(`/file`, { json: this.json, path, fileName });
            Toast.success("등록되었습니다");
          }
        });
    },
    isJsonString(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },
  },
};
</script>
<style>
textarea.langData {
  max-height: 500px;
}
</style>
